import { Dashboard, PageLayout } from '@components/common';
import { useAppearance } from '@fourthwall/appearance';
import { BackButton, Banner, ButtonGroup, ConfirmModal, HeadContent, ToolbarButton, useMediaQueryContext, useModalContext, } from '@fourthwall/components';
import { DownloadIcon } from '@fourthwall/icons';
import { AnalyticsBarChart, AnalyticsCard, AnalyticsChart, StatsTable, } from '@fourthwall/module-analytics';
import { isWebView } from '@fourthwall/utils';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { AnalyticsToolbar, ChartEntityGroupSelect, DevicesSelect, IntervalSelect, PrecisionSelect, RangeSelect, TiersSelect, } from '../../../../modules/AnalyticsParams';
import * as S from './AnalyticsReport.styled';
export const AnalyticsReportView = ({ title, bottomContent, banner, backButtonLabel, backButtonTo, exportButton, chart, analyticsBarChart, statsTable, }) => {
    const { appearance } = useAppearance();
    const media = useMediaQueryContext();
    const { open } = useModalContext();
    const location = useLocation();
    const locationState = location.state;
    const backButtonProps = (() => {
        if (locationState?.from) {
            return {
                label: locationState.from.label,
                to: locationState.from.location,
            };
        }
        return {
            label: backButtonLabel,
            to: backButtonTo,
        };
    })();
    const handleExportClick = () => {
        open(ConfirmModal, {
            title: 'Export report',
            text: 'Report will be exported as CSV table.',
            confirmLabel: 'Export',
            onConfirm: exportButton.onConfirm,
        });
    };
    const renderStatsTable = () => {
        if (analyticsBarChart && !media.tablet) {
            return (React.createElement(AnalyticsBarChart, { ...analyticsBarChart, emptyMessage: "No data found in this date range." }));
        }
        return (React.createElement(StatsTable, { columns: statsTable.columns, data: statsTable.data, emptyMessage: statsTable.emptyMessage, isLoading: statsTable.isLoading, getRowBold: statsTable.getRowBold }));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: title, titleTemplate: isWebView() ? title : undefined }),
        React.createElement(PageLayout, null,
            React.createElement(Dashboard.Section, { name: isWebView() ? undefined : title, topContent: isWebView() ? undefined : React.createElement(BackButton, { ...backButtonProps }), bottomContent: bottomContent, toolbarContent: isWebView() || !exportButton.enabled ? undefined : (React.createElement(ButtonGroup, null,
                    React.createElement(ToolbarButton, { label: "Export", icon: DownloadIcon, onClick: handleExportClick }))) },
                React.createElement(AnalyticsToolbar, null,
                    React.createElement(RangeSelect, { excludedPrecision: ['WEEK', 'MONTH', 'YEAR'] }),
                    React.createElement(PrecisionSelect, { excludedPrecision: ['WEEK', 'MONTH', 'YEAR'] }),
                    React.createElement(ChartEntityGroupSelect, null),
                    React.createElement(TiersSelect, null),
                    React.createElement(IntervalSelect, null),
                    React.createElement(DevicesSelect, null)),
                React.createElement(S.ContentContainer, null,
                    banner && React.createElement(Banner, { ...banner }),
                    chart && (React.createElement(AnalyticsCard, { title: chart.title, value: chart.value, statistics: React.createElement(AnalyticsChart, { description: chart.description, series: chart.series, formatDate: chart.formatDate, formatValue: chart.formatValue, minSecondaryAxesValue: chart.minSecondaryAxesValue, appearance: appearance }), isLoading: chart.isLoading, isError: chart.isError })),
                    renderStatsTable())))));
};
